import { Box, Typography } from "@mui/material";
import React from "react";
import { SiteStatusEnum } from "./Home";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { sitesStatus } from "./hooks/useGetSitesStatus";

type Props = {
  siteStatusData: sitesStatus;
};

export const SiteStatus = ({ siteStatusData }: Props) => {
  const getStatusIcon = (siteStatus: SiteStatusEnum) => {
    switch (siteStatus) {
      case SiteStatusEnum.Offline:
        return (
          <FontAwesomeIcon
            icon={faMinusCircle}
            style={{ marginRight: "10px", color: "#CC2553" }}
          />
        );
      case SiteStatusEnum.Online:
        return (
          <FontAwesomeIcon
            icon={faCheckCircle}
            style={{ marginRight: "10px", color: "#2AAC76" }}
          />
        );
      case SiteStatusEnum.Unknown:
        return (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ marginRight: "10px", color: "#E2AC37" }}
          />
        );
      default:
        return (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ marginRight: "10px", color: "#E2AC37" }}
          />
        );
    }
  };

  const getLastSeen = (date: Date | string) => {
    return moment.utc(date).to(moment(), true);
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        {siteStatusData.lastSeenTimestamp && (
          <Typography variant="subtitle1">
            Last Seen: {getLastSeen(siteStatusData.lastSeenTimestamp)}
          </Typography>
        )}
        <p style={{ fontSize: "16px" }}>
          <b>Name: {siteStatusData.name}</b>
        </p>
        <p>
          <b>Site Name: {siteStatusData.siteName ?? "--"}</b>
        </p>

        {siteStatusData.errors &&
          siteStatusData.errors.map((error) => (
            <Typography variant="subtitle1" color="error">
              <b>Error Message:</b> {error.message}
            </Typography>
          ))}
      </div>
      <div style={{ fontSize: "1.5rem" }}>
        {getStatusIcon(siteStatusData.status as SiteStatusEnum)}
      </div>
    </Box>
  );
};
